import {
  VENUE_LIST_REQUEST,
  VENUE_LIST,
  VENUE_LIST_ERROR,
} from '../actions/types'

var initialState = {
  venues: [],
  loading: false,
}

export default function(state = initialState, action) {
  switch (action.type) {
    case VENUE_LIST_REQUEST:
      return {
        loading: action.payload.loading,
      }
    case VENUE_LIST:
      return {
        ...state,
        loading: action.payload.loading,
        venues: action.payload.venues,
      }
    case VENUE_LIST_ERROR:
      return {
        ...state,
        loading: action.payload.loading,
        error: action.payload.error,
      }
    default:
      return {...state}
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/venue_list_reducer.js
 **/